'use client'

import { SimpleTrialSummaryCard } from '@components/app/DoctorPage/SimpleTrialSummaryCard'
import HorizontalButtonCarousel from '@components/app/HomePage/ConditionCardSection/HorizontalCarousel'
import { Text } from '@components/primitives/Text'
import { getCount, sortDictionaryByCount } from '@lib/utilities/getCount'
import isNotNull from '@lib/utilities/object/isNotNull'
import type { HospitalPageData } from '@modules/hospitals/cache/getCachedHospitalPageData'
import { useState } from 'react'

const CONDITION_FILTER_COUNT = 10

export const RecruitingTrialsFilterList = ({
  hospitalPageData,
}: {
  hospitalPageData: HospitalPageData
}) => {
  const trialsForSection = hospitalPageData.uniqueTrialsByNctId

  const conditionsByCount = sortDictionaryByCount(
    getCount(
      trialsForSection
        .flatMap((trial) =>
          trial.conditions.map(
            (condition) => condition.condition.colloquialTermStripped,
          ),
        )
        .filter(isNotNull),
    ),
  )
    .map(([condition, _count]) => condition)
    .slice(0, CONDITION_FILTER_COUNT)

  const [activeCondition, setActiveCondition] = useState<string | undefined>(
    conditionsByCount[0],
  )

  if (trialsForSection.length === 0) {
    return null
  }

  const trialsToShow = trialsForSection.filter(
    (trial) =>
      activeCondition
        ? trial.conditions.find(
            (condition) =>
              condition.condition.colloquialTermStripped === activeCondition,
          )
        : true, // don't filter if no condition is selected
  )

  return (
    <section id='recruitingTrials'>
      <Text element='h3' styleName='h4'>
        Clinical Trials running at {hospitalPageData.name}
      </Text>
      <div className='mt-4 flex flex-col gap-2'>
        <HorizontalButtonCarousel
          activeFilter={activeCondition}
          filters={conditionsByCount}
          onFilterChange={setActiveCondition}
          type='condition-picker'
        />
        {trialsToShow.slice(0, 3).map((trial) => (
          <SimpleTrialSummaryCard key={trial.slug} trial={trial} />
        ))}
      </div>
    </section>
  )
}
